import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'

import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'

export default props => {
    useStyles(classes)
    const { items, onTab, selectedItem } = props

    const selectedName = selectedItem?.name || items?.[0]?.name

    return <Swiper
        className={classes.Swiper}
        slidesPerView="auto"
    >
        {
            items?.map((item, index) => <SwiperSlide className={classes.SwiperSlide} key={index}>
                <span onClick={e => onTab(item)} className={`${classes.Tab} ${item.name === selectedName? classes.Selected: ''}`}>{item.name}</span>
            </SwiperSlide>)
        }
    </Swiper>
}